<template>
  <div>
    <v-overlay v-if="loader"> Cargando </v-overlay>
    <v-form @submit.prevent="checkForm">
     

      <v-row>
         <v-col cols="12" class="pb-0">
        <v-text-field
          v-model="Nombre"
          label="Nombre Horario"
          :error-messages="errors.nombre ? [errors.nombre] : []"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>
        <v-col cols="6">
          <v-menu
            ref="startMenu"
            v-model="startMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="HoraInicial"
                label="Hora Inicial"
                readonly
                v-bind="attrs"
                v-on="on"
                :error-messages="errors.hora ? [errors.hora] : []"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-time-picker
              v-model="HoraInicial"
              @change="startMenu = false"
              format="24hr"
              :minute-increment="10"
            ></v-time-picker>
          </v-menu>
        </v-col>

        <v-col cols="6">
          <v-menu
            ref="endMenu"
            v-model="endMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="HoraFinal"
                label="Hora Final"
                readonly
                v-bind="attrs"
                v-on="on"
                :error-messages="errors.hora ? [errors.hora] : []"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-time-picker
              v-model="HoraFinal"
              @change="endMenu = false"
              format="24hr"
              :minute-increment="10"
              :min="HoraInicial"
            ></v-time-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-col cols="12" class="pb-0">
        <v-checkbox v-model="status" label="Activo"></v-checkbox>
      </v-col>

      <v-col cols="12" class="text-right">
        <v-btn color="green" dark type="submit">Guardar</v-btn>
        <v-btn color="red" dark @click="$emit('toggle', false)">Cancelar</v-btn>
      </v-col>
    </v-form>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "HorarioForm",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      Nombre: "",
      HoraInicial: null,
      HoraFinal: null,
      status: true,
      loader: true,
      modProshop: false,
      modClubPlaya: false,
      modRestaurante: false,
      errors: {},
      Id: "",
    };
  },
  methods: {
    // selectDate(arg) {
    //   this.input_date = moment(arg);
    //   if (this.input_date > this.input_date_final) {
    //     this.input_date_final = moment(arg);
    //   }
    // },
    // selectDateFinal(arg) {
    //   this.input_date_final = moment(arg);
    // },
    checkForm: function (e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      if (!this.Nombre) {
        this.errors.nombre = "El nombre del horario es obligatorio";
        valid = false;
      } else {
        this.errors.nombre = false;
      }
      if (
        !this.HoraInicial ||
        !this.HoraFinal ||
        this.HoraFinal == this.HoraInicial
      ) {
        this.errors.hora = "Un horario correcto es requerido";
        valid = false;
      } else {
        this.errors.hora = false;
      }

      if (valid) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.$data.horas = this.Hour;
        this.$emit("successData", this.$data, doAction);
      }
    },
  },
  computed: {
    initialHour() {
      if (this.HoraInicial === "") {
        return this.minDate;
      } else {
        let hour = new moment(this.HoraInicial);
        return hour.format("HH:mm");
      }
    },
    Hour() {
      let ini = moment(this.HoraInicial, ["HH:mm:ss", "HH:mm"]);
      let fini = moment(this.HoraFinal, ["HH:mm:ss", "HH:mm"]);

      return { inicial: ini, final: fini };
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
  },
  watch: {},
  // beforeMount: function () {},

  mounted() {
    this.loader = false;
    if (this.edit) {
      this.Id = this.dataEdit.id;
      this.Nombre = this.dataEdit.Nombre;
      this.HoraInicial = moment(
        this.dataEdit.HoraInicio,
        ["HH:mm:ss", "HH:mm"]
      ).format("HH:mm");
      this.HoraFinal = moment(
        this.dataEdit.HoraTermino,
        ["HH:mm:ss", "HH:mm"]
      ).format("HH:mm");
      this.status = this.dataEdit.Activo;
    }
  },
};
</script>
